import { usePlaygroundContext } from "../context/PlaygroundContext";

export function usePlayground() {
  return usePlaygroundContext();
}
